import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
// import autobind from 'autobind-decorator';

@observer
class FanSearchBar extends React.Component {
	render () {
		return (
			<div className="grid-x"
				style={{
					marginRight: '6vw',
					width: '18vw',
					paddingTop: '1.7rem'
				}}
			>
                <input type="text" placeholder="Search" data-ta="FanSearchBar" id="FanSearchBar" onChange={ this.props.searchChange } value={ this.props.searchTerm } style={{borderRadius: '1vw'}}/>
			</div>
		);
    }
}

export default FanSearchBar;
